import es from './es';
import en from './en';
import eu from './eu';

export const TRANSLATIONS = { es, eu, en };

export const AVAILABLE_LANGUAGES = [
  { code: 'es', name: 'Español', flag: 'https://flagcdn.com/w40/es.png' },
  { code: 'eu', name: 'Euskara', flag: '/assets/flags/eu.png' },
  { code: 'en', name: 'English', flag: 'https://flagcdn.com/w40/gb.png' }
];

export default TRANSLATIONS;
